export interface NoticeReadLike {
  id: number;
  created_at?: string;
  createdAt?: string;
  updated_at?: string;
  updatedAt?: string;
}

const STORAGE_PREFIX = "hongmo_notice_read";

export const noticeReadStorageKey = (userKey?: string | number | null) =>
  `${STORAGE_PREFIX}:${userKey || "anonymous"}`;

export const noticeVersionKey = (notice: NoticeReadLike) => {
  const version =
    notice.updated_at || notice.updatedAt || notice.created_at || notice.createdAt || "";
  return `${notice.id}:${version}`;
};

export const getLocalReadNoticeSet = (userKey?: string | number | null) => {
  try {
    const raw = localStorage.getItem(noticeReadStorageKey(userKey));
    const values = raw ? JSON.parse(raw) : [];
    return new Set<string>(Array.isArray(values) ? values : []);
  } catch {
    return new Set<string>();
  }
};

export const isNoticeReadLocally = (
  userKey: string | number | null | undefined,
  notice: NoticeReadLike
) => {
  const values = getLocalReadNoticeSet(userKey);
  return values.has(noticeVersionKey(notice)) || values.has(String(notice.id));
};

export const markNoticeReadLocally = (
  userKey: string | number | null | undefined,
  notice: NoticeReadLike
) => {
  const values = getLocalReadNoticeSet(userKey);
  values.add(noticeVersionKey(notice));
  const nextValues = Array.from(values).slice(-300);
  localStorage.setItem(noticeReadStorageKey(userKey), JSON.stringify(nextValues));
};